(function () {
  const TRIPLE_SELECTOR = '.magio-pdp__dual-gallery--triple';
  const QUAD_SELECTOR = '.magio-pdp__dual-gallery--quad';
  const SCROLL_GALLERY_SELECTOR = `${TRIPLE_SELECTOR}, ${QUAD_SELECTOR}`;
  const SPACER_SELECTOR = '[data-magio-dual-scroll-spacer]';
  const VIEWPORT_SELECTOR = '[data-magio-dual-scroll-viewport]';
  const LAYOUT_SELECTOR = '.magio-pdp__layout--dual';
  const INFO_INNER_SELECTOR = '.magio-pdp__info-inner';
  const GAP_PX = 12;
  /* Figma node 670:154 — each top cell ~472.64 × 628.61px */
  const TOP_CELL_ASPECT = 628.6099853515625 / 472.6400146484375;
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function getCellHeight(gallery) {
    const styles = window.getComputedStyle(gallery);
    const gapValue = parseFloat(styles.rowGap || styles.gap) || GAP_PX;
    const galleryWidth = gallery.clientWidth || 1;
    const cellWidth = (galleryWidth - gapValue) / 2;
    return Math.round(cellWidth * TOP_CELL_ASPECT);
  }

  function getWideImageHeight(gallery, wideCell) {
    const img = wideCell?.querySelector('.magio-pdp__dual-image--wide, .magio-pdp__dual-image');
    const galleryWidth = gallery.clientWidth || 1;

    if (img?.naturalWidth > 0 && img?.naturalHeight > 0) {
      return Math.round((img.naturalHeight / img.naturalWidth) * galleryWidth);
    }

    return Math.round(galleryWidth * 1.35);
  }

  function getScrollDistance(gallery, viewport) {
    return Math.max(0, gallery.offsetHeight - viewport.offsetHeight);
  }

  function syncQuadGalleryHeights() {
    document.querySelectorAll(QUAD_SELECTOR).forEach((gallery) => {
      if (!DESKTOP_MQ.matches) {
        gallery.style.removeProperty('--magio-dual-cell-h');
        return;
      }

      const cellHeight = getCellHeight(gallery);
      gallery.style.setProperty('--magio-dual-cell-h', `${cellHeight}px`);
    });
  }

  function syncTripleGalleryHeights() {
    document.querySelectorAll(TRIPLE_SELECTOR).forEach((gallery) => {
      const spacer = gallery.closest(SPACER_SELECTOR);
      const viewport = gallery.closest(VIEWPORT_SELECTOR);

      if (!DESKTOP_MQ.matches || !spacer || !viewport) {
        gallery.style.transform = '';
        if (spacer) spacer.style.height = '';
        return;
      }

      const layout = gallery.closest(LAYOUT_SELECTOR);
      const infoInner = layout?.querySelector(INFO_INNER_SELECTOR);
      const wideCell = gallery.querySelector('[data-magio-dual-wide]');
      if (!infoInner) return;

      const infoHeight = infoInner.offsetHeight;
      const cellHeight = getCellHeight(gallery);
      const wideHeight = Math.max(240, getWideImageHeight(gallery, wideCell));

      gallery.style.setProperty('--magio-dual-viewport-h', `${infoHeight}px`);
      gallery.style.setProperty('--magio-dual-top-h', `${cellHeight}px`);
      gallery.style.setProperty('--magio-dual-cell-h', `${cellHeight}px`);
      gallery.style.setProperty('--magio-dual-wide-h', `${wideHeight}px`);

      viewport.style.height = `${infoHeight}px`;

      const scrollDistance = getScrollDistance(gallery, viewport);
      spacer.style.height = `${infoHeight + scrollDistance}px`;

      updateGalleryScroll(gallery);
    });
  }

  function syncGalleryHeights() {
    syncQuadGalleryHeights();
    syncTripleGalleryHeights();
  }

  function updateGalleryScroll(gallery) {
    const spacer = gallery.closest(SPACER_SELECTOR);
    const viewport = gallery.closest(VIEWPORT_SELECTOR);
    if (!spacer || !viewport || !DESKTOP_MQ.matches) {
      gallery.style.transform = '';
      return;
    }

    const scrollDistance = getScrollDistance(gallery, viewport);
    if (scrollDistance <= 0) {
      gallery.style.transform = '';
      return;
    }

    const spacerTop = spacer.getBoundingClientRect().top;
    const offset = Math.min(Math.max(-spacerTop, 0), scrollDistance);
    gallery.style.transform = `translate3d(0, ${-offset}px, 0)`;
  }

  function onScroll() {
    document.querySelectorAll(TRIPLE_SELECTOR).forEach(updateGalleryScroll);
  }

  function initMobileGallery() {
    document.querySelectorAll('[data-magio-dual-mobile-thumbs]').forEach((thumbs) => {
      if (thumbs.dataset.magioMobileInit === 'true') return;
      thumbs.dataset.magioMobileInit = 'true';

      const gallery = thumbs.closest('[data-magio-pdp-dual-gallery]');
      if (!gallery) return;

      const slides = gallery.querySelectorAll('[data-mobile-slide-index]');

      thumbs.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-mobile-thumb-index]');
        if (!thumb) return;

        const index = thumb.getAttribute('data-mobile-thumb-index');

        slides.forEach((slide) => {
          slide.classList.toggle('is-mobile-active', slide.getAttribute('data-mobile-slide-index') === index);
        });

        thumbs.querySelectorAll('[data-mobile-thumb-index]').forEach((button) => {
          const isActive = button.getAttribute('data-mobile-thumb-index') === index;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      });
    });
  }

  function init() {
    syncGalleryHeights();
    initMobileGallery();

    document.querySelectorAll(TRIPLE_SELECTOR).forEach((gallery) => {
      gallery.querySelectorAll('.magio-pdp__dual-image--wide').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', syncGalleryHeights, { once: true });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => syncGalleryHeights());
      document.querySelectorAll(`${LAYOUT_SELECTOR} ${INFO_INNER_SELECTOR}`).forEach((info) => {
        observer.observe(info);
      });
      document.querySelectorAll(SCROLL_GALLERY_SELECTOR).forEach((gallery) => {
        observer.observe(gallery);
      });
    }

    DESKTOP_MQ.addEventListener('change', syncGalleryHeights);
    window.addEventListener('resize', syncGalleryHeights);
    document.addEventListener('shopify:section:load', () => {
      syncGalleryHeights();
      initMobileGallery();
      onScroll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
